@if (showAppShell()) {
  <app-header />
  <main class="main-content">
    <router-outlet />
  </main>
  <app-footer />
}
<app-cookie-consent />
<app-city-onboarding />
